module.exports = __webpack_public_path__ + "img/index-coop6.4edd09a8.png";